<template>
<layout-content :title="`${editName}管理`">
  <template #toolbar>
    <section class="toolbar-btn">
      <el-button
        type="primary"
        size="small"
        @click="showFull"
      >{{flag ? '返回' : '全屏'}}</el-button>
      <el-button
        :disabled="!site.id"
        type="success"
        icon="el-icon-download"
        size="small"
        @click="onDownloadBtnClick()"
      >导出{{editName}}</el-button>
      <el-button
        v-if="isAdmin || orgTypeId === 1"
        :disabled="!site.id"
        type="orange"
        icon="el-icon-plus"
        size="small"
        @click="onOpenEditor()"
      >新建{{editName}}</el-button>
    </section>
  </template>

  <template #body>
    <el-table
      ref="table"
      :data="list"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border double-click-table"
      style="width: 100%"
      @selection-change="onSelectionChange"
      @row-click="onSelectSiteDevice"
    >
      <el-table-column label="序号" width="50" fixed>
        <template slot-scope="{$index, row}" fixed>
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">{{$index + 1}}</div>
        </template>
      </el-table-column>

<!--      <el-table-column prop="sn" label="序列号" fixed />-->
      <!-- <el-table-column prop="deviceName" label="仪器类别" fixed width="150">
        <template slot-scope="{row}">
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">{{(deviceCategoryMap[row.deviceCategoryId] || {}).name}}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="deviceName" label="仪器名称" width="200" fixed>
        <template slot-scope="{row}">
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">{{(deviceMap[row.deviceId] || {}).name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="deviceBrand" label="仪器品牌" width="200">
        <template slot-scope="{row}">
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">{{(deviceMap[row.deviceId] || {}).brand}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="deviceModel" label="仪器型号" width="150">
        <template slot-scope="{row}">
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">{{(deviceMap[row.deviceId] || {}).model}}</div>
        </template>
      </el-table-column>
      <el-table-column label="运维组织" min-width="200">
        <template slot-scope="{row}">
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">{{orgMap[row.opsOrgId] ? orgMap[row.opsOrgId].name : ''}}</div>
        </template>
      </el-table-column>
      <el-table-column label="数采来源" min-width="200">
        <template slot-scope="{row}">
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">{{dasMap[row.dasId] ? dasMap[row.dasId].name : ''}}</div>
        </template>
      </el-table-column>
<!--      <el-table-column label="时间标识" width="90">-->
<!--        <template slot-scope="{row}">{{dataTimeMap[row.dataTimeTypeId] ? dataTimeMap[row.dataTimeTypeId].name : ''}}</template>-->
<!--      </el-table-column>-->
      <el-table-column label="是否启用" align="center" width="80">
        <template slot-scope="{row}">
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">
            <my-switch
              v-model="row.status"
              @click.native.stop
              @change="onChangeStatus(row, ...arguments)"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="{row}">
          <div class="site-device-cell" @dblclick="onOpenEditor(row)">
            <div class="table-operator-wrapper">
              <span class="table-operator-btn edit-btn" @click="onOpenEditor(row)">
                <i class="el-icon-edit" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </template>

  <template #editor>
    <site-device-editor
      ref="editor"
      :site-id="site.id || '0'"
      :ops-orgs="orgs"
      :das-list="dasList"
      :data-time-types="dataTimeTypes"
      @save="onSiteDeviceSave"
      @close="onCancelHighlightTableRow"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../BaseListEditor'
import SiteDeviceEditor from './SiteDeviceEditor'
import CSVDownloader from '../../../utils/CSVDownloader'
import {mapGetters} from 'vuex'

export default {
  name: 'SiteDeviceListEditor',
  extends: BaseListEditor,
  components: {SiteDeviceEditor},
  props: {
    site: {
      required: true,
      type: Object
    },
    currentDisplaySiteDevice: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      orgs: [],
      dasList: [],
      downloadName: '',
      flag: false
    }
  },
  computed: {
    ...mapGetters({
      orgTypeId: 'Profile/orgTypeId'
    }),
    apiKey () {
      return 'SiteDevice'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return '站房仪器'
    },
    orgMap () {
      return this.orgs.reduce((map, org) => {
        map[org.id] = org
        return map
      }, {})
    },
    dasMap () {
      return this.dasList.reduce((map, das) => {
        map[das.id] = das
        return map
      }, {})
    },
    dataTimeTypes () {
      return Object.freeze([{
        id: -1,
        name: '前置时间'
      }, {
        id: 1,
        name: '后置时间'
      }])
    },
    dataTimeMap () {
      return this.dataTimeTypes.reduce((map, dataTimeType) => {
        map[dataTimeType.id] = dataTimeType
        return map
      }, {})
    }
  },
  methods: {
    showFull () {
      this.flag = !this.flag
      this.$eventBus.emit('setShowFullFlag', this.flag ? 2 : 0)
    },
    onSiteSelectChanged (site) {
      this.downloadName = site.name + '站_仪器'
      let {id: siteId} = site

      if (!siteId) {
        this.list = []
        return
      }

      this.query.siteId = siteId
      this.getList()
    },
    setList (list) {
      this.list = list || []
    },
    onSelectSiteDevice (siteDevice) {
      this.selectSiteDevice(siteDevice)
    },
    selectSiteDevice (siteDevice) {
      let {currentSiteDevice} = this

      if (!currentSiteDevice || currentSiteDevice.id !== siteDevice.id) {
        this.currentSiteDevice = siteDevice
        this.$emit('update:currentDisplaySiteDevice', Object.freeze(JSON.parse(JSON.stringify(siteDevice))))
      }

      this.$nextTick(() => {
        let table = this.getTable()

        if (table) {
          let id = siteDevice.id
          let tableData = table.tableData.find(siteDevice => siteDevice.id === id)
          table.setCurrentRow(tableData)
        }
      })
    },
    onSiteDeviceSave (siteDevice) {
      this.siteDevice = siteDevice
      this.getList()
    },
    afterQuery () {
      let {siteDevice} = this

      if (siteDevice) {
        this.selectSiteDevice(siteDevice)
        this.siteDevice = null
      } else {
        let {list} = this
        this.selectSiteDevice(list.length > 0 ? list[0] : {
          id: null
        })
      }
    },
    getElTableCsvData (tableColumns, columnKeys, dataList) {
      let firstColumn = tableColumns.map((el) => {
        if (el.label !== '序号' && el.label !== '操作') {
          return el.label
        }
      }).filter(Boolean)
      let data = dataList.map((el) => {
        let temp = []
        columnKeys.forEach((item) => {
          let { id } = item
          temp.push(el[id])
        })
        return temp
      })
      return [firstColumn, ...data]
    },
    onDownloadBtnClick () {
      let {list, deviceMap, orgMap, dasMap, downloadName} = this
      let dataList = list.map(el => {
        let obj = {
          deviceName: deviceMap[el.deviceId] ? deviceMap[el.deviceId].name : '',
          deviceBrand: deviceMap[el.deviceId] ? deviceMap[el.deviceId].brand : '',
          deviceModel: deviceMap[el.deviceId] ? deviceMap[el.deviceId].model : '',
          orgName: orgMap[el.opsOrgId] ? orgMap[el.opsOrgId].name : '',
          das: dasMap[el.dasId] ? dasMap[el.dasId].name : '',
          state: el.status ? '已启用' : '未启用'
        }
        return obj
      })

      let keys = []
      for (let key in dataList[0]) {
        keys.push({id: key})
      }

      let data = this.getElTableCsvData(this.$refs['table'].columns, keys, dataList)

      CSVDownloader(data, downloadName)
    }
  },
  watch: {
    site: {
      immediate: true,
      handler (site) {
        if (site) {
          this.onSiteSelectChanged(site)
        }
      }
    }
  },
  created () {
    this.$api.Org.getList({
      typeId: 2
    }).then(orgs => {
      this.orgs = Object.freeze(orgs)
    }).catch(console.error)
    this.$api.DAS.getList().then(dasList => {
      this.dasList = Object.freeze(dasList)
    }).catch(console.error)
  }
}
</script>

<style lang="scss" scoped>
.double-click-table {
  /deep/ {
    td {
      padding: 0 !important;

      .cell {
        padding: 0 !important;
      }
    }
  }

  .site-device-cell {
    padding: 6px 10px;
    user-select: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/SiteDeviceListEditor.vue